var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 179,
    viewBox: "0 0 250 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2 105.008L100.8 150.608C104 153.808 105.533 157.541 105.4 161.808C105.267 166.075 103.733 169.808 100.8 173.008C97.6 176.208 93.8 177.875 89.4 178.008C85 178.141 81.2 176.608 78 173.408L4.8 100.208C1.6 97.008 0 93.2747 0 89.008C0 84.7413 1.6 81.008 4.8 77.808L78 4.608C81.2 1.408 85 -0.125333 89.4 0.008C93.8 0.141333 97.6 1.808 100.8 5.008C103.733 8.208 105.267 11.9413 105.4 16.208C105.533 20.4747 104 24.208 100.8 27.408L55.2 73.008H233.6C238.133 73.008 241.933 74.5413 245 77.608C248.067 80.6747 249.6 84.4747 249.6 89.008C249.6 93.5413 248.067 97.3413 245 100.408C241.933 103.475 238.133 105.008 233.6 105.008H55.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrowLeftWhite.4cc03cf8e4e8a0d17022589dd671fe79.svg";
export { ForwardRef as ReactComponent };